import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import logger from '../../../../utils/logger';
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Breadcrumbs,
  Link
} from '@mui/material';

const Page = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: '#f8f9fa',
  minHeight: '100vh'
}));

const ContainerCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: 12,
  boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
  maxWidth: 1040,
  margin: '0 auto',
  backgroundColor: '#fff'
}));

const InnerCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 10,
  boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
  border: '1px solid #eee',
  backgroundColor: '#fff',
  minHeight: 720,
  '& .MuiOutlinedInput-root': {
    borderRadius: 1.25 * theme.shape.borderRadius
  }
}));

const PaymentEditPage = () => {
  const navigate = useNavigate();
  const { paymentId } = useParams();

  const [form, setForm] = useState({
    withGstDesc: '',
    paymentMode: 'Cash',
    bankName: 'SBI Bank',
    chequeNumber: '02012025',
    paymentWithGst: '3434',
    netPayment: '2323',
    gst: '233',
    advance: '3434',
    pending: '0',
    topUpAmount: '2323',
    netSaleAfterTopUp: '233',
    teleShare: '53454545454',
    bdmShare: '2313',
    paymentDate: '2025-05-05',
    emiPerMonth: '2313',
    paymentMonth: 'January',
    paymentYear: '2025',
    saleCreditMonth: 'January',
    saleCreditYear: '2025',
    credited: false,
    confirmByAccount: false,
    comment: ''
  });

  const handleChange = (key) => (e) => {
    const value = e.target?.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    logger.log('Submitting payment update for', paymentId, form);
    navigate(-1);
  };

  return (
    <Page>
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs>
          <Link color="inherit" onClick={() => navigate('/admin-dashboard')} sx={{ cursor: 'pointer' }}>Dashboard</Link>
          <Link color="inherit" onClick={() => navigate(-1)} sx={{ cursor: 'pointer' }}>Payment Profile</Link>
          <Typography color="text.primary">Payment Form</Typography>
        </Breadcrumbs>
        <Typography variant="h4" color="primary" fontWeight={700} sx={{ mt: 1 }}>Payment Form</Typography>
        <Typography variant="body2" color="text.secondary">
          Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.
        </Typography>
      </Box>

      <ContainerCard>
        <Box textAlign="center" mb={2}>
          <Typography variant="h6" fontWeight={700}>Basic Information</Typography>
          <Typography variant="body2" color="text.secondary">
            Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing
          </Typography>
          {paymentId && (
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
              Editing Payment: {paymentId}
            </Typography>
          )}
        </Box>

        <InnerCard component="form" onSubmit={handleSubmit}>
          <Box sx={{ border: '1px solid #e9ecef', borderRadius: 2, p: 3, backgroundColor: '#fff' }}>
          <Grid container spacing={2.5}>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                <FormControlLabel control={<Checkbox />} label="GMB" />
                <FormControlLabel control={<Checkbox />} label="Website" />
                <FormControlLabel control={<Checkbox />} label="SMO" />
                <FormControlLabel control={<Checkbox />} label="Other" />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <TextField size="medium" fullWidth label="Payment with GST*" value={form.withGstDesc} onChange={handleChange('withGstDesc')} />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl size="medium" fullWidth>
                <InputLabel>Payment Mode*</InputLabel>
                <Select label="Payment Mode*" value={form.paymentMode} onChange={handleChange('paymentMode')}>
                  <MenuItem value="Cash">Cash</MenuItem>
                  <MenuItem value="Online">Online</MenuItem>
                  <MenuItem value="NEFT">NEFT</MenuItem>
                  <MenuItem value="Cheque">Cheque</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth label="Bank Name*" value={form.bankName} onChange={handleChange('bankName')} />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth label="Cheque Number*" value={form.chequeNumber} onChange={handleChange('chequeNumber')} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth label="Payment with GST*" value={form.paymentWithGst} onChange={handleChange('paymentWithGst')} />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth label="Net Payment*" value={form.netPayment} onChange={handleChange('netPayment')} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth label="GST*" value={form.gst} onChange={handleChange('gst')} />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth label="Advance*" value={form.advance} onChange={handleChange('advance')} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth label="Pending*" value={form.pending} onChange={handleChange('pending')} />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth label="Top Up Amount*" value={form.topUpAmount} onChange={handleChange('topUpAmount')} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth label="Net Sale After Top Up Amount" value={form.netSaleAfterTopUp} onChange={handleChange('netSaleAfterTopUp')} />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth label="Tele Share*" value={form.teleShare} onChange={handleChange('teleShare')} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth label="BDM Share*" value={form.bdmShare} onChange={handleChange('bdmShare')} />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth type="date" label="Payment Date*" InputLabelProps={{ shrink: true }} value={form.paymentDate} onChange={handleChange('paymentDate')} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField size="medium" fullWidth label="EMI Payment per month*" value={form.emiPerMonth} onChange={handleChange('emiPerMonth')} />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl size="medium" fullWidth>
                <InputLabel>Payment Month*</InputLabel>
                <Select label="Payment Month*" value={form.paymentMonth} onChange={handleChange('paymentMonth')}>
                  {['January','February','March','April','May','June','July','August','September','October','November','December'].map(m => (
                    <MenuItem key={m} value={m}>{m}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl size="medium" fullWidth>
                <InputLabel>Payment Year*</InputLabel>
                <Select label="Payment Year*" value={form.paymentYear} onChange={handleChange('paymentYear')}>
                  {['2024','2025','2026'].map(y => (
                    <MenuItem key={y} value={y}>{y}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl size="medium" fullWidth>
                <InputLabel>Sale Credit Month*</InputLabel>
                <Select label="Sale Credit Month*" value={form.saleCreditMonth} onChange={handleChange('saleCreditMonth')}>
                  {['January','February','March','April','May','June','July','August','September','October','November','December'].map(m => (
                    <MenuItem key={m} value={m}>{m}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl size="medium" fullWidth>
                <InputLabel>Sale Credit Year*</InputLabel>
                <Select label="Sale Credit Year*" value={form.saleCreditYear} onChange={handleChange('saleCreditYear')}>
                  {['2024','2025','2026'].map(y => (
                    <MenuItem key={y} value={y}>{y}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                <FormControlLabel control={<Checkbox checked={form.credited} onChange={handleChange('credited')} />} label="Amount Credited" />
                <FormControlLabel control={<Checkbox checked={form.confirmByAccount} onChange={handleChange('confirmByAccount')} />} label="Confirm By Account" />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <TextField size="medium" fullWidth label="Comment*" value={form.comment} onChange={handleChange('comment')} />
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2.5, mt: 2 }}>
                <Button size="medium" variant="outlined" color="inherit" onClick={() => navigate(-1)}>Cancel</Button>
                <Button size="medium" type="submit" variant="contained" sx={{ minWidth: 140 }}>Update</Button>
              </Box>
            </Grid>
          </Grid>
          </Box>
        </InnerCard>
      </ContainerCard>
    </Page>
  );
};

export default PaymentEditPage;
